// The console's opening, the same as the household app's launch (BrandIntro,
// page 1 of the prototype): the whole screen MyGaz blue, the logo dead centre
// with three white rings breathing out of it, the wordmark and the tagline
// near the bottom. It holds while the session and the first data load, never
// less than the app's own 1.8 s, then fades into the console. The bar under
// the name is real (Ruben, 2 Nov 2026): it fills as each loading step answers.
import { useEffect, useState } from 'react';
import { S } from '../lib/strings';
import { Wordmark } from './Wordmark';

export function Splash({ leaving = false, progress = 0 }: { leaving?: boolean; progress?: number }) {
  const pct = Math.round((leaving ? 1 : Math.max(0.04, Math.min(1, progress))) * 100);
  return (
    <div className={'splash' + (leaving ? ' out' : '')} role="status" aria-label={S.splash.aria}>
      <div className="sp-mark">
        <i className="sp-ring" /><i className="sp-ring" /><i className="sp-ring" />
        <img src="./mygaz-logo.png" alt="" width={220} height={220} />
      </div>
      <div className="sp-foot">
        <div className="sp-word"><Wordmark white /><span>Ops</span></div>
        <div className="sp-sub">{S.splash.sub}</div>
        <div className="sp-bar" role="progressbar" aria-label={S.splash.loading} aria-valuemin={0} aria-valuemax={100} aria-valuenow={pct}><i style={{ width: pct + '%' }} /></div>
      </div>
    </div>
  );
}

/** Keeps the splash up until `ready` and at least `min` ms, then fades it out. */
export function SplashGate({ ready, progress, min = 1800 }: { ready: boolean; progress: number; min?: number }) {
  const [minDone, setMinDone] = useState(false);
  const [gone, setGone] = useState(false);
  useEffect(() => { const t = setTimeout(() => setMinDone(true), min); return () => clearTimeout(t); }, [min]);
  const leaving = ready && minDone;
  useEffect(() => { if (!leaving) return; const t = setTimeout(() => setGone(true), 450); return () => clearTimeout(t); }, [leaving]);
  if (gone) return null;
  return <Splash leaving={leaving} progress={progress} />;
}
